import { Box, FormHelperText, Grid } from "@mui/material";
import SearchableSelect, {
  SelectOption,
} from "app/components/SearchableSelect";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { API_URL } from "utils/constants";
import { getDefaultHeaders } from "utils/helpers";
import { request } from "utils/request";
import { useStyles } from "../styles";

export type WallCategoryOption = {
  key: string;
  title: string;
  icon?: string;
  background?: string;
};

interface TProps {
  value: string;
  xs?: number;
  changeValue: (value: string) => void;
  disabled?: boolean;
  error?: string;
}

const CategoryField = (props: TProps) => {
  const { t } = useTranslation();
  const styles = useStyles();
  const [items, setItems] = useState<WallCategoryOption[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        setLoading(true);
        const response = (await request(
          `${API_URL}/v1/daily-activity/categories`,
          { method: "GET", headers: getDefaultHeaders() }
        )) as WallCategoryOption[];
        if (!cancelled && Array.isArray(response)) {
          setItems(response);
        }
      } catch (e) {
        if (!cancelled) setItems([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const hasError = !!props?.error;

  const options: SelectOption[] = items.map((item) => ({
    label: t(`WALL_CATEGORIES.${item.key}`),
    value: item.key,
    raw: item,
  }));

  return (
    <Grid item xs={props.xs ? props.xs : 12}>
      <label className={styles.label}>{t("DAILY_ACTIVITY.CATEGORY")}</label>
      <SearchableSelect
        options={options}
        value={props.value || ""}
        onChange={(val) => props.changeValue(String(val))}
        disabled={props.disabled}
        loading={loading}
        searchable
        error={hasError}
        placeholder={t("DAILY_ACTIVITY.SELECT_CATEGORY") as string}
        className={styles.textEnabled}
      />
      <Box sx={{ display: "flex" }}>
        {hasError && <FormHelperText error>{props?.error}</FormHelperText>}
      </Box>
    </Grid>
  );
};

export default CategoryField;
